const TOKEN_NAME = "scalatimes.jwt.token";

function getJwtToken() {
    return window.localStorage.getItem(TOKEN_NAME);
}

function login(token) {
    window.localStorage.setItem(TOKEN_NAME, token);
}

function logout() {
    window.localStorage.removeItem(TOKEN_NAME)
}

function isLoggedOut() {
    return !isLoggedIn()
}

function logoutOnErrorIfNecessary(error) {
    const isTokenOutdated = error.response && error.response.status === 401;
    if(isTokenOutdated) {
        logout();
    }
}

function isLoggedIn() {
    return getJwtToken() != null
}

module.exports = {
    isLoggedIn: isLoggedIn,
    isLoggedOut: isLoggedOut,
    getJwtToken: getJwtToken,
    login: login,
    logout: logout,
    logoutOnErrorIfNecessary: logoutOnErrorIfNecessary
};


// WEBPACK FOOTER //
// ./src/common/services/authService.js